import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from 'src/environments/environment';
import { CopyFeedbackPopupComponent } from 'src/app/shared/components';
import { ActivateFormValue } from '../../models/activate-link.model';
import { PAYMENT_METHODS_MAP } from 'src/app/domains/sales/activation-link/models/activation-link.model';
import { calculateExpiryDate } from 'src/app/domains/sales/activation-link/utils/activation-link-utils';

@Component({
  selector: 'gdp-activation-link-new-plans',
  templateUrl: './activation-link-new-plans.component.html',
  styleUrls: ['./activation-link-new-plans.component.scss']
})
export class ActivationLinkNewPlansComponent {
  public modalContent: string = '';
  public activationFormControl = new FormControl<ActivateFormValue>(null);

  @ViewChild('activationNewPlansLinkPopup', { static: false }) linkPopup: CopyFeedbackPopupComponent;

  constructor(
    private modalService: NgbModal
  ) { }

  public onSubmit(): void {
    if (this.activationFormControl.valid) {
      const formValue = this.activationFormControl.value;
      this.modalService.open(this.linkPopup, { size: 'lg' });
      const expiryDate = calculateExpiryDate(formValue);
      const token = btoa(JSON.stringify({
        name: formValue.name,
        date: expiryDate.getTime(),
        deal_id: formValue.deal_id,
        sms: formValue.sms,
        coupon: null,
        payment_methods: PAYMENT_METHODS_MAP[formValue.paymentMethod]
      }));
      const params = `?token=${token}&country=${formValue.country.iso2.toUpperCase()}`;
      this.modalContent = `${environment.activationLink.essentialProfessionalPrimeCheckout}${params}`
    }
  }

}
